import { useCallback } from "react";

import BoardTabView from "./BoardTabView";

/**
 * Props for BoardTab container component
 */
interface BoardTabContainerProps {
  /** Board identifier */
  readonly boardId: string;
  /** Display name of the board */
  readonly name: string;
  /** Whether this tab is currently active */
  readonly isActive: boolean;
  /** Callback when a board tab is selected */
  readonly onBoardSelect: (boardId: string) => void;
}

/**
 * Container component for individual board tab
 * Handles press logic and passes presentation props to view
 * @param root0 - Component props
 * @param root0.boardId - Board identifier
 * @param root0.name - Display name of the board
 * @param root0.isActive - Whether this tab is currently active
 * @param root0.onBoardSelect - Callback when a board tab is selected
 */
const BoardTabContainer = ({
  boardId,
  name,
  isActive,
  onBoardSelect,
}: BoardTabContainerProps) => {
  const handlePress = useCallback(() => {
    onBoardSelect(boardId);
  }, [onBoardSelect, boardId]);

  return <BoardTabView name={name} isActive={isActive} onPress={handlePress} />;
};

export default BoardTabContainer;
